import { BubbleGameBoard } from 'js/bubbleCore/BubbleGameBoard';
import { Bubble } from 'js/bubbleCore/bubbles/types';
import {
  checkShootedGridCollisions,
  testBubbleGridCollision,
  checkFlyingBubbleGridBubbleCollision,
} from 'js/bubbleCore/handlers/collisions/checkShootedGridCollisions';
import { updateBubblesInSpace } from 'js/bubbleCore/handlers/updateBubblesInSpace';
import { updatePositionInSpace } from 'js/bubbleCore/handlers/updatePositionInSpace';
import { loopSpace } from 'js/bubbleCore/utils/loopSpace';
import {
  IEvent,
  EventType,
  Wall,
  createBubbleUpdatedEvent,
  createShootingSpaceGridCollisionEvent,
  BubbleDestroyReason,
  createBubbleDestroyedEvent,
  filterEvents,
} from 'js/bubbleCore/events';
import { removeFromPlace } from 'js/bubbleCore/handlers/removeFromPlace';
import { Place } from 'js/bubbleCore/types';

export function handleBubblesInShootingSpace(board: BubbleGameBoard): void {
  loopSpace(board.getData().shootingSpace, (bubble) => updateBubble(board, bubble));
  filterEvents(board.getEventsQueue(), EventType.BubbleSpaceLimitCollision)
    .forEach((event) => {
      if (event.data.wall === Wall.Top) {
        const { bubble } = event.data;
        removeFromPlace(bubble, board.getData(), Place.ShootingSpace);
        board.getEventsQueue().push(
          createBubbleDestroyedEvent(bubble, BubbleDestroyReason.TopCollision)
        );
      }      
    });
}

function updateBubble(board: BubbleGameBoard, bubble: Bubble): void {
  updatePositionInSpace(bubble, board.getData().shootingSpace, board.getEventsQueue());
  const events = board.getEventsQueue();
  const grid = board.getData().grid;

  const colliders = testBubbleGridCollision(bubble, grid);
  while(colliders && checkFlyingBubbleGridBubbleCollision(bubble, colliders[0], grid, bubble.radiusInGrid)) {
    bubble.hexSpaceX -= bubble.velX * 0.1;
    bubble.hexSpaceY -= bubble.velY * 0.1;
  }

  events.push(createBubbleUpdatedEvent(bubble));
  if (colliders) events.push(createShootingSpaceGridCollisionEvent(bubble, colliders));
}